import React, { useState, useMemo } from 'react';
import {
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Popover,
  Button,
  TextField,
  Divider,
} from '@mui/material';

export default function ColumnSelector({ columns, columnVisibilityModel, setColumnVisibilityModel }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const filteredColumns = useMemo(() => {
    return columns.filter((col) =>
      col.headerName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, columns]);

  const allVisible = useMemo(() => {
    return columns.every((col) => columnVisibilityModel[col.field] !== false);
  }, [columns, columnVisibilityModel]);

  const toggleAll = (checked) => {
    const newModel = {};
    columns.forEach((col) => {
      newModel[col.field] = checked;
    });
    setColumnVisibilityModel(newModel);
  };

  const toggleColumn = (field) => {
    setColumnVisibilityModel((prev) => {
      const currentlyVisible = prev[field] !== false;
      return {
        ...prev,
        [field]: !currentlyVisible,
      };
    });
  };

  return (
    <>
      <Button variant="outlined" onClick={handleClick} sx={{ mb: 2 }}>
        Show/Hide Columns
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box
          sx={{
            width: 250,
            height: 400,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* 🔍 Search input - fixed */}
          <Box sx={{ p: 2 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search column..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>

          {/* ✅ Column checkboxes - scrollable */}
          <Box sx={{ flex: 1, overflowY: 'auto', px: 2 }}>
            <FormGroup>
              {filteredColumns.map((col) => (
                <FormControlLabel
                  key={col.field}
                  control={
                    <Checkbox
                      checked={columnVisibilityModel[col.field] !== false}
                      onChange={() => toggleColumn(col.field)}
                    />
                  }
                  label={col.headerName}
                />
              ))}
            </FormGroup>
          </Box>

          {/* ✅ Show/Hide All - fixed */}
          <Box sx={{ p: 2, borderTop: '1px solid #eee' }}>
            <Divider sx={{ mb: 1 }} />
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allVisible}
                    onChange={(e) => toggleAll(e.target.checked)}
                  />
                }
                label="Show/Hide All"
              />
            </FormGroup>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
